import PropTypes from 'prop-types';

import styles from './FormError.module.scss';

const FormError = ({ error = '' }) => {
  return error ? (
    <div data-test="form-error" className={styles['form-error']}>
      <span>{error}</span>
    </div>
  ) : null;
};

FormError.propTypes = {
  error: PropTypes.string
};

export default FormError;
